import React from "react";
import TableCard from "../../shared/TableCard/TableCard";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import Index from "./index";

export default function OurWorkTable({ heading, styleGuides, onDelete, loading, search, setSearch }) {
    const { history } = Index();

    const actions = (d) => {
        return (
            <div className="flex justify-content-around gap-1">
                <i className="pi pi-eye cursor-pointer" onClick={() => history.push(`our-works/view/${d._id}`)}></i>
                <i className="pi pi-pencil cursor-pointer" onClick={() => history.push(`our-works/edit/${d._id}`)}></i>
                <i className="pi pi-trash cursor-pointer" onClick={(e) => onDelete(e, d._id)}></i>
            </div>
        );
    };

    const filters = {
        time: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        subscriptionExpireOn: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    };

    return (
        <>
            <TableCard title={heading} onSearch={setSearch} searchKeyword={search} buttonTitle="Add Work" linkTo={`/our-works/add`}>
                <DataTable
                    paginator
                    value={styleGuides}
                    selectionMode="checkbox"
                    showGridlines
                    filter={filters}
                    filterDisplay="menu"
                    rows={10}
                    loading={loading}
                    emptyMessage="No work found."
                >
                    <Column header="Name" field="name"></Column>
                    {/* <Column header="Description" field="description"></Column> */}
                    <Column body={actions} style={{ width: "100px" }} header="Action"></Column>
                </DataTable>
            </TableCard>
        </>
    );
}
